import { useEffect, useState } from "react";

/**
 * True only on devices with a real pointer, so hover-only media never loads on
 * a phone. Starts false: a touch device should not pay for the extra image
 * during the first paint while it waits for the query to settle.
 */
export function useHoverCapable() {
  const [canHover, setCanHover] = useState(false);

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return undefined;
    const query = window.matchMedia("(hover: hover) and (pointer: fine)");
    setCanHover(query.matches);
    const onChange = (event) => setCanHover(event.matches);
    query.addEventListener("change", onChange);
    return () => query.removeEventListener("change", onChange);
  }, []);

  return canHover;
}
